import VueAnalytics from 'vue-analytics'

export function analytics (Vue, router) {
  const analyticsId = process.env.VUE_APP_OWAL_ANALYTICS_GA_APP_ID || 'UA-XXX-X'
  Vue.use(VueAnalytics, {
    id: analyticsId,
    router,
  })
}
